/**
 * Labels de campos de qualificação do cliente — valores persistidos em snake_case/UPPER_CASE.
 */

export const TEMPO_PROCURA_OPTIONS = [
  { value: 'menos_de_1_mes', label: 'Menos de 1 mês' },
  { value: '1_a_3_meses', label: '1 a 3 meses' },
  { value: '3_a_6_meses', label: '3 a 6 meses' },
  { value: 'mais_de_6_meses', label: 'Mais de 6 meses' },
] as const;

export type TempoProcuraValue = (typeof TEMPO_PROCURA_OPTIONS)[number]['value'];

export const TEMPO_PROCURA_LABELS: Record<string, string> = Object.fromEntries(
  TEMPO_PROCURA_OPTIONS.map(({ value, label }) => [value, label])
);

function normalizeFieldKey(value: string): string {
  return value.trim().toLowerCase();
}

/** Fallback: 1_a_3_meses → 1 A 3 Meses → melhorar para legível */
function humanizeTempoProcura(value: string): string {
  return value
    .trim()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word, index) => {
      if (/^\d+$/.test(word)) return word;
      if (word === 'a' && index > 0) return 'a';
      if (word === 'de' || word === 'mes' || word === 'meses') {
        return word === 'mes' ? 'mês' : word === 'meses' ? 'meses' : 'de';
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ')
    .replace(/\bmeses\b/g, 'meses')
    .replace(/\bmes\b/g, 'mês');
}

/**
 * @example formatTempoProcuraLabel('1_a_3_meses') → '1 a 3 meses'
 */
export function formatTempoProcuraLabel(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return '—';
  const key = normalizeFieldKey(String(value));
  return TEMPO_PROCURA_LABELS[key] ?? humanizeTempoProcura(String(value));
}
